import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h4","key":"svg-0"}],["path",{"d":"M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3","key":"svg-1"}],["path",{"d":"M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3","key":"svg-2"}]]

const IconCursorText = createReactComponent('outline', 'cursor-text', 'CursorText', __iconNode);

export default IconCursorText;